import React from 'react';
import { matchPath, useLocation, useNavigate, useParams } from 'react-router';
import BookingCalendar from '../../model/BookingCalendar';
//import {Moment} from 'moment-timezone';
import { CalendarMode, default as Moleskine } from '../calendar/Moleskine';
import { Badge, Button, Col } from 'antd';

import { dateAfterToday } from '../Common';
// import RequestCalendar from '../model/RequestCalendar';
import './RequestAgenda.css';
import Calendar, { CalendarProps } from '../../model/Calendar';
import { EventProps } from '../../model/Event';

import RequestAgendaItem from './RequestAgendaItem';
import parse from 'url-parse';
import { Link } from '../../types/PageInfo';
import { nextPeriod, prevPeriod } from '../../utils/builders/date-builder';
import MediaQuery from 'react-responsive';
import Flex from '../StyledComponents/Flex';
import Popover from 'antd/es/popover';
import IconClose from '../icons/IconClose';
import Tooltip from 'antd/lib/tooltip';
import Cursor from '../StyledComponents/Cursor';
import { convertDate, isNullOrUndefined, MONTH_CONF, useBuildDateLabel } from '../../utils';
import { useTranslation } from '@nic-react-i18n/core';
import dayjs from 'dayjs';
import { Params } from 'react-router-dom';
import { AppConf } from '../../AppConf';
//import keycloak from "../../keycloak";
import { useKeycloak } from '@nic-react/auth';
import { KeycloakInstance } from 'keycloak-js';

const Group = Button.Group;

export interface AgendaProp {
    agenda: BookingCalendar;
    mode: CalendarMode;
    selectHandler: (date: dayjs.Dayjs) => void;
    value: dayjs.Dayjs;
    baseURI?: string;
    requestCalendar: boolean;
    bookDate: (date: string) => void;
}

const YEAR = 'year';
const MONTH = 'month';
//const DAY = 'day';
const ID = 'id';

const getTitle = (params: Params, locale: string): string | undefined => {
    let title;
    if (params) {
        let year: number = Number(params.year);
        let month: number = Number(params.month);
        if (!isNullOrUndefined(year) && ! isNullOrUndefined(month)) {
            const date = dayjs().year(year).month(month - 1).day(1)
            title = convertDate(locale, date.toDate(), MONTH_CONF)
        }
    }
    return title;
};
/*
interface BookParams {
    period: string;
    year?: string;
    month?: string;
    day?: string;
}
 */
/*
const paramsFromLocation = (location: Location): BookParams  => {

    let res: BookParams = {} as BookParams;

    let url = parse(location.pathname + location.search, true);

    if (!isNullOrUndefined(url) && !isNullOrUndefined(url.query)) {
        res.period = 'month';
        res.month = url.query[MONTH];
        res.year = url.query[YEAR];
        res.day = url.query[DAY];
    }

    return res;
};
*/
const transformLink = (link: Link, keycloak: KeycloakInstance): string | undefined => {

    let res;
    let url = parse(link.href);

    const apiPath = AppConf.getApiPath(keycloak.realm??'')

    let matchUrl = matchPath(`${apiPath}/requests/:id/calendar/month/:year/:month`, url.pathname);

    //console.log('MatchUrl: ', matchUrl, url);

    if (matchUrl !== undefined && matchUrl !== null && matchUrl.params !== null && matchUrl.params !== undefined) {
        let id = (matchUrl.params as any)[ID];
        let month = (matchUrl.params as any)[MONTH];
        let year = (matchUrl.params as any)[YEAR];
        res = `/requests/${id}/calendar/month/${year}/${month}`;
    }

    return res;
};

/*
const buildDateLabel = (t: TFunction,  next: Moment, period: string): string => {
    let res: string;
    switch (period) {
        case 'week':
            let d = moment(next).format(formatter[period]);
            res = `${t('title.week')} ${d}`;
            break;
        case 'range':
            res = '';
            break;
        default:
            res = moment(next).format((formatter as any)[period]);
            break;
    }
    return res;
};
*/
const AgendaTitle: React.FC<any> = (props) => {
    const {agenda, direction} = props;
    const {keycloak} = useKeycloak()
    const navigate = useNavigate()
    const location = useLocation()
    const params = useParams()
    const {locale} = useTranslation()

    let nextLink: string | undefined = agenda.links.next && transformLink(agenda.links.next, keycloak);
    let prevLink: string | undefined  =  agenda.links.previous && transformLink(agenda.links.previous, keycloak);
    let title = getTitle(params, locale);

    const {t} = useTranslation()


    const prevDate = prevPeriod(params);

    const nextDate = nextPeriod(params);

    const justifyTitle = (direction  === 'row' ? 'flex-start' : 'center');
    const justifyDate = (direction === 'row' ? 'flex-end' : 'center');

    return (
        <div>
            <Flex
                direction={props.direction}
                justify={justifyTitle}
                align={'center'}
                className="header-toolbar header-toolbar--3cols"
                style={{
                    alignContent:  'center',
                }}
            >
                <div className="header-toolbar-item left">
                    <div
                        onClick={() => {
                            const fullPath = location.pathname + location.search;
                            let url = parse(fullPath, true);

                            url.query = {request: (!isNullOrUndefined(url.query.request) ? url.query.request : '')};
                            let newUrl = parse(url.toString());

                            navigate(newUrl.pathname + newUrl.query);
                        }}
                    >
                        <Tooltip title={t('tooltip.close')}>
                            <Cursor kind={'pointer'}>
                                <IconClose/>
                            </Cursor>
                        </Tooltip>
                    </div>
                </div>
                <div className="header-toolbar-item center">
                    <div className="title">{title}</div>
                </div>
                <Flex
                    direction={'row'}
                    justify={justifyDate}
                    className="header-toolbar-item right"
                >
                    <Group style={{display: 'flex'}}>
                        <Button
                            disabled={isNullOrUndefined(prevLink)}
                            onClick={() => {
                                if (prevLink !== undefined) {
                                    navigate(prevLink);
                                }
                            }}
                        >
                            <Flex
                                direction={'row'}
                                align={'center'}
                                className={'margin-top-auto margin-bottom-auto text-align-center'}
                            >
                                <i className={'fal fa-angle-left'}/>
                                <div className={'padding-left-10'}>
                                    {useBuildDateLabel(prevDate, params.period??'month')}
                                </div>
                            </Flex>
                        </Button>
                        <Button
                            disabled={isNullOrUndefined(nextLink)}
                            onClick={() => {
                                if (nextLink !== undefined) {
                                    navigate(nextLink)
                                }
                            }}
                        >
                            <Flex
                                direction={'row'}
                                align={'center'}
                                className={'margin-top-auto margin-bottom-auto text-align-center'}
                            >
                                <div className={'padding-right-10'}>
                                    {useBuildDateLabel( nextDate, params.period??'month')}
                                </div>
                                <i className={'fal fa-angle-right'}/>
                            </Flex>
                        </Button>
                    </Group>
                </Flex>
            </Flex>
        </div>
    );
};

const RequestAgendaTitle: React.FC<any> = (props) => {
    return (
        <span>
            <MediaQuery minWidth={800}>
                <AgendaTitle direction={'row'} {...props} />
            </MediaQuery>
            <MediaQuery minWidth={300} maxWidth={799}>
                <AgendaTitle direction={'column'} {...props} />
            </MediaQuery>
        </span>
    );
};



const RequestAgenda:  React.FC<AgendaProp> = (props) =>  {
    const {t} = useTranslation()
//    const {keycloak} = useKeycloak()
//    dayjs.tz.setDefault("Europe/Rome");


   // const tZone = dayjs();
    const monthCellRender = (date: dayjs.Dayjs) => {

        const {agenda} = props;

        let planner = agenda.availableDates;

        let res = null;

        if (!dateAfterToday(date)) {
            res = (
                <div className="notes-month margin-left-auto margin-right-auto width-40">
                    <i style={{color: 'orange'}} className={'fal fa-ban'}/>
                </div>
            );

        } else {
            if (planner[date.year()] &&
                planner[date.year()][date.month() + 1] &&
                planner[date.year()][date.month() + 1].length > 0) {
                res = (
                    <div className="notes-month margin-right-auto margin-left-auto width-40">

                        <div className={'cardTitle text-align-center'} >
                            <span> {t('booking.event.month')}</span>
                        </div>
                        <div className={'text-align-center'}>
                            <Badge
                                overflowCount={1000}
                                count={planner[date.year()][date.month() + 1].length}
                                style={{backgroundColor: '#fff', color: '#999', boxShadow: '0 0 0 1px #d9d9d9 inset'}}
                            />
                        </div>
                    </div>
                );
            }
        }
        return res;
    }

    const disabledDate  = (date: dayjs.Dayjs): boolean => {
        const {agenda} = props;
        let planner = agenda.availability;

        return ! (planner as any)[date.format('YYYY-MM-DD')];
    }

    const renderDataCellPopup = (agenda: BookingCalendar, date: dayjs.Dayjs) => {
        let planner = agenda.availability;
        let timeValues: any = [];
        let res;
        const planObject = (planner as any)[dayjs(date).format('YYYY-MM-DD')];
        if (!isNullOrUndefined(planObject)) {

            planObject.times.forEach((time: any, i: number) => {
                const splitted = time.time.split(':');
                timeValues.push(
                    <div
                        key={i}
                    >
                        <div className={'text-align-center'}>
                            <span> <i className={'fal fa-clock font-size-9pt'}/></span>
                            <span className={'font-size-9pt padding-left-5'}>
                                {`${splitted[0]}:${splitted[1]}`}
                            </span>
                        </div>
                    </div>
                );
            });
        }
        if (timeValues.length === 0) {
            res = (
                <div>emp</div>
            );
        } else {
            res = (
                <Flex
                    direction={'column'}
                    justify={'space-between'}
                >
                    {timeValues}
                </Flex>
            );
        }

        let title = (
            <span className={'text-align-center'}>
                {dayjs(date).format('dddd DD MMMM YYYY')}
            </span>

        );

        return (
            <Popover
                content={res}
                title={title}
            >
                <div className={'small-booking-items'}>{timeValues.length}</div>
            </Popover>
        );
    }

    const dateCellRender = (date: dayjs.Dayjs) => {
        const {agenda} = props;

        let planner = agenda.availability;

        let res = <></>;
        const planObject = (planner as any)[dayjs(date).format('YYYY-MM-DD')];
        if (!isNullOrUndefined(planObject)) {
            let timeValues: any = [];

            planObject.times.forEach((time: any, i: number) => {
                const splitted = time.time.split(':');
                timeValues.push(
                    <Col span={12} key={i}>
                        <div className={'text-align-center'}>
                            <span > <i className={'fal fa-clock font-size-9pt'} /></span>
                            <span className={'font-size-9pt padding-left-5'}>
                                {`${splitted[0]}:${splitted[1]}`}
                            </span>
                        </div>
                    </Col>
                );
            });

            res = (
                <span className={'full-width'}>
                    <MediaQuery minWidth={860}>
                        {(matches) => {
                            if (matches) {
                                return (
                                    <Flex
                                        direction={'row'}
                                        wrap={'wrap'}
                                        justify={'space-between'}
                                    >
                                        {timeValues}
                                    </Flex>
                                );
                            } else {
                                return (
                                    <Flex
                                        direction={'column'}
                                    >
                                        {renderDataCellPopup(agenda, date)}
                                    </Flex>
                                );
                            }
                        }}

                    </MediaQuery>
                </span>
            );

        }
  //      let comp = this.renderDialog(date, agenda);

        return (
            <RequestAgendaItem
                selectedDate={date}
                calendar={agenda}

                bookDate={props.bookDate}
            >
                {res}
            </RequestAgendaItem>
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const panelChangeHandler = (date?: dayjs.Dayjs, mode?: CalendarMode): void => {
        // console.log("panelChangeHandler: Date: ", date, " mode ", mode);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const selectHandler = (date?: dayjs.Dayjs) => {
        return;
    }
        const {mode, value,   baseURI, requestCalendar} = props;
        let events: CalendarProps = {events: new Array<EventProps>()};
        let agenda = new Calendar(events);

        let mytitle = <RequestAgendaTitle {...props} />;

        return (
            <Moleskine
                title={mytitle}
                mode={mode}
                date={value}
                agenda={agenda}
                prefixCls="ant-picker-calendar"
                fullscreen={true}
                onSelect={selectHandler}
                dateCellRender={dateCellRender}
                monthCellRender={monthCellRender}
                onPanelChange={panelChangeHandler}
                baseURI={baseURI}
                disabledDate={disabledDate}
                requestCalendar={requestCalendar}
            />
        );

}
export default RequestAgenda